{
  "activeMiners": "المعدنون النشطون",
  "approvedRewards": "المكافآت المعتمدة",
  "assetOverview": "الحساب والأصول",
  "buyExalt": "شراء EXALT",
  "community": "المجتمع",
  "dashboardSubtitle": "منصة تداول أصول رقمية احترافية",
  "dashboardTitle": "لوحة التحكم",
  "displayCurrency": "عملة العرض",
  "earn": "اربح",
  "estimatedExchangeWalletValue": "القيمة التقديرية لمحفظة المنصة",
  "exchangeActivity": "نشاط المنصة",
  "hideBalances": "إخفاء الأرصدة",
  "leaderboard": "لوحة المتصدرين",
  "live": "مباشر",
  "liveMarketBoard": "● لوحة السوق المباشرة",
  "loading": "جاري التحميل...",
  "marketCap": "القيمة السوقية",
  "marketStatus": "حالة السوق",
  "miningPool": "مجمع التعدين",
  "noActivityYet": "لا يوجد نشاط",
  "notifications": "الإشعارات",
  "pendingRewards": "المكافآت المعلقة",
  "portfolioValue": "قيمة المحفظة",
  "quickActions": "إجراءات سريعة",
  "readyTradingWithdrawal": "جاهز للتداول أو السحب",
  "recentActivity": "آخر النشاطات",
  "recentOrders": "الطلبات الأخيرة",
  "refresh": "تحديث",
  "refreshDashboard": "تحديث لوحة التحكم",
  "security": "الأمان والتحقق",
  "showBalances": "إظهار الأرصدة",
  "submitListing": "إرسال إدراج",
  "topGainer": "الأعلى ارتفاعاً",
  "topLoser": "الأعلى انخفاضاً",
  "totalPortfolioValue": "إجمالي قيمة المحفظة",
  "trendingCoins": "العملات الرائجة",
  "unavailable": "غير متاح",
  "viewMarketBoard": "عرض لوحة السوق",
  "waitingAdminApproval": "بانتظار موافقة الإدارة",
  "walletStatus": "حالة المحفظة"
}